import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuProps,
} from "@chakra-ui/react";
import { useState } from "react";
import { menuSortFavorite } from "../../constants/ListMenuSort";
import { SelectOption } from "../../constants/SelectOption";

interface Props extends MenuProps {
  item?: SelectOption[];
  title?: string;
  onSelected: (select: SelectOption | undefined) => void;
}

export const MenuSort = ({
  item = menuSortFavorite,
  title = "Urutkan",
  onSelected,
  ...rest
}: Props) => {
  const [displayText, setDisplayText] = useState<string | undefined>(undefined);

  return (
    <Menu isLazy {...rest}>
      <MenuButton as={Button} rightIcon={<ChevronDownIcon />}>
        {displayText ? displayText : title}
      </MenuButton>
      <MenuList>
        {item.map((menu) => (
          <MenuItem
            key={menu.id}
            onClick={() => {
              setDisplayText(menu.name);
              onSelected(menu);
            }}
          >
            {menu.name}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
